export class TransferIdRequest{
    packingStockTransferId:number;
    createdUser?:string;
    versionFlag?:number;
}